import { render, staticRenderFns } from "./SettingDomain.vue?vue&type=template&id=d34d4f3a&scoped=true"
import script from "./SettingDomain.vue?vue&type=script&lang=js"
export * from "./SettingDomain.vue?vue&type=script&lang=js"
import style0 from "./SettingDomain.vue?vue&type=style&index=0&id=d34d4f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34d4f3a",
  null
  
)

export default component.exports